// extracted by mini-css-extract-plugin
export default {"brandPromo":"iF-z","carousel":"jF-z"};